import { handleGqlResponseBody } from "@/utils/apollo.util";
import { GET_INGREDIENTS_PAGINATION_QUERY } from "@/graphql/queries/configuration/ingredient/get-ingredients-pagination.query";

const ingredient = {
  actions: {
    async getIngredientsQuery({ commit }, { skip, take, orderBy, query }) {
      return await handleGqlResponseBody(({ query: queryMethod }) => {
        return queryMethod({
          query: GET_INGREDIENTS_PAGINATION_QUERY,
          variables: {
            skip,
            take,
            orderBy,
            query,
          },
          fetchPolicy: "no-cache",
        });
      });
    },
  },
};

export default ingredient;
